/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=1c52d0c6&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=1c52d0c6&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(script)


import exportComponent from "F:\\php-project\\admin_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c52d0c6"],['__file',"library/layouts/VabLayoutFloat/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c52d0c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c52d0c6', __exports__)) {
    api.reload('1c52d0c6', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=1c52d0c6&scoped=true", () => {
    api.rerender('1c52d0c6', render)
  })

}


export default __exports__